import { useQuery } from '@tanstack/react-query'
import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

export interface AdLibraryAd {
  ad_active_status: string
  ad_creation_time: string
  ad_creative_bodies?: string[]
  ad_creative_link_captions?: string[]
  ad_creative_link_titles?: string[]
  ad_delivery_start_time: string
  ad_delivery_stop_time?: string
  ad_snapshot_url: string
  id: string
  impressions?: { lower_bound: string; upper_bound: string }
  languages?: string[]
  page_id: string
  page_name: string
  publisher_platforms: string[]
  spend?: { lower_bound: string; upper_bound: string }
  target_locations?: {
    code?: string
    excluded?: boolean
    name?: string
    type?: string
  }[]
}

export interface AdsLibrarySearchParams {
  ad_active_status?: string
  ad_reached_countries?: string
  ad_type?: string
  after?: string
  limit?: number
  search_page_ids: string
}

interface AdsLibrarySearchResponse {
  data: AdLibraryAd[]
  paging?: { cursors?: { after?: string; before?: string }; next?: string }
  success: boolean
}

const getAdsLibrarySearch = async (
  params: AdsLibrarySearchParams
): Promise<AdsLibrarySearchResponse | null> => {
  const sessionId = getSessionIdFromLocalStorage()
  if (!sessionId) return null

  const { data } = await analyticsApi().get<AdsLibrarySearchResponse>(
    '/v1_private/ads-library/search',
    {
      params: {
        ...params,
        search_page_ids: JSON.stringify([params.search_page_ids]),
      },
    }
  )

  return data
}

export const useGetAdsLibrarySearchQuery = (params: AdsLibrarySearchParams) => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery({
    enabled: !!sessionId && !!params.search_page_ids,
    queryFn: () => getAdsLibrarySearch(params),
    queryKey: [QueryKey.GET_ADS_LIBRARY_SEARCH, params],
  })
}
